module.exports = __webpack_public_path__ + "static/media/default_group.732c015d.png";